<template>
  <div class="rightMenu">
    <ul>
      <li>
        <span class="rightDetail telDetail telphone">182-4500-2033</span><a href="tel:15118106535" class="rightIcon telphone"><img class="menuIcon" src="../assets/img/telIcon.png"/></a>
      </li>
      <li>
        <span class="rightDetail wxDetail wxIcon"><img class="wechat" :src="require('../assets/wechatPic.jpg')" /></span><a href="javascript:void(0)" class="rightIcon wxIcon"><img class="menuIcon" src="../assets/img/wxIcon.png"/></a>
      </li>
      <li v-if="btnFlag">
        <a href="javascript:void(0)" class="rightIcon backIcon" @click="backTop"><img class="menuIcon" src="../assets/img/backIcon.png"/></a>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: "RightMenu",
  data() {
    return {
      scrollTop:0,
      btnFlag: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
    console.log(this.scrollTop);
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods : {
    backTop () {
      const that = this
      console.log(that.scrollTop);
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        console.log(that.scrollTop);
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    }
  }
}
</script>
<style scoped>
.rightMenu{
  position: fixed;
  right: 0;
  top: 45%;
  z-index: 90;
}
.rightMenu li{
  display: block;
  margin: 0;
  padding: 0;
  position: relative;
  right: 0;
  float: right;
  clear: both;
  height: 50px;

}
.rightMenu .rightIcon{
  width: 50px;
  height: 50px;
  display: inline-block;
  border-radius: 25px;
  text-align: center;
}
.rightMenu .telphone{
  background-color: #1296db;
}
.rightMenu .wxIcon{
  background-color: #62b900;
}
.rightMenu .backIcon{
  background-color: #c4a464;
}
.rightMenu .telDetail{
  height: 50.5px;
  width: 150px;
  display: none;
  text-align: center;
  line-height: 50px;
  position: relative;
  top:-9px;
}
.rightMenu .menuIcon{
  width: 32px;
  margin-top: 8px;
}
.rightMenu .wxDetail{
  width: 150px;
  background-color: #FFFFFF;
  position: absolute;
  right:50px;
  display: none;
}
.rightMenu .wxDetail .wechat{
  width: 150px;
}
.rightMenu li:hover .rightIcon{
  border-radius: 0;
}
.rightMenu li:hover .rightDetail{
  display: inline-block !important;
}
@media screen and (max-width:600px){

}
</style>



// WEBPACK FOOTER //
// src/components/RightMenu.vue